import FormFeeItem from './form_fee_item';

const ApplicationFeeItem = FormFeeItem.extend({});

export default ApplicationFeeItem;
